import { RigidBody } from "../rigidBody";
export class PluginBody extends RigidBody {
    worldId;
    motionType;
    localTransform;
    localTransformInverse;
    constructor(runtime, info) {
        const shape = info.shape;
        let localTransform = null;
        if (shape !== null) {
            localTransform = shape.localTransform;
            info.collisionGroup = shape.collisionGroup;
            info.collisionMask = shape.collisionMask;
            const material = shape.material;
            if (material) {
                info.friction = material.friction;
                info.restitution = material.restitution;
            }
        }
        super(runtime, info);
        this.worldId = info.worldId;
        this.motionType = info.motionType;
        this.localTransform = localTransform;
        this.localTransformInverse = localTransform?.invert() ?? null;
    }
}
